export const API_HOST = <string>import.meta.env.VITE_API_HOST; //"https://api.rechtsportal24.de"
export const API_PATH = "";
export const MERCURE_URL = <string>import.meta.env.VITE_MERCURE_URL;
export const MERCURE_PREFIX = <string>import.meta.env.VITE_MERCURE_PREFIX;
export const ALGOLIA_SEARCH_API_KEY = import.meta.env.VITE_ALGOLIA_SEARCH_API_KEY || "";
export const ALGOLIA_APPLICATION_ID = import.meta.env.VITE_ALGOLIA_APPLICATION_ID || "";
export const ALGOLIA_ORGANIZATION_INDEX = import.meta.env.VITE_ALGOLIA_ORGANIZATION_INDEX || "";
